import PropTypes from 'prop-types'
import Render from 'lyjs/es/components/Render'
import Echart from 'lyjs/es/components/Echart'

import theme from 'services/chartThemes/walden-roi'

function Chart(props) {
  const {
    option: {
      baseOption,
      media: mediaOption = [],
      ...otherOption
    } = {},
    media = [],
    ...otherProps
  } = props

  const option = {
    baseOption: {
      ...baseOption,
      ...otherOption
    },
    media: [
      ...mediaOption,
      ...media
    ]
  }

  return Render({
    option,
    ...otherProps
  })
}
Chart.defaultProps = {
  component: Echart,
  theme,
  height: 320
}

if (process.env.NODE_ENV !== 'production') {
  Chart.propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    height: PropTypes.number,
    option: PropTypes.object,
    media: PropTypes.arrayOf(PropTypes.object),
  }
}

export default Chart



// WEBPACK FOOTER //
// ./src/components/Chart/Chart.js